import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "className", "content", "placement", "variation", "enableFollowCursor"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import Tippy from '@tippyjs/react/headless';
import { followCursor } from 'tippy.js';
import { motion, useAnimation } from 'framer-motion';
import { getTransformOrigin } from '../helpers/utility';
import TippyArrow from './TippyArrow';
import { jsx as ___EmotionJSX } from "@emotion/react";

const StylesTooltipVariables = (theme, variation) => ({
  background: variation === 'light' ? theme.color.light.base : theme.color.dark.base,
  borderColor: variation === 'light' ? theme.color.border.base : theme.color.dark.base,
  borderRadius: theme.borderRadius.base,
  color: variation === 'light' ? theme.fontColor.base : theme.contrast.base,
  padding: theme.space.small
});

const Tooltip = _ref => {
  let {
    children,
    className,
    content,
    placement = 'top',
    variation = 'light',
    enableFollowCursor = false
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  const controls = useAnimation();
  const variants = {
    hidden: {
      opacity: 0,
      scale: 0.5
    },
    visible: {
      opacity: 1,
      scale: 1
    }
  };

  const handleOnMount = () => {
    controls.start('visible');
  };

  const handleOnHide = async instance => {
    await controls.start('hidden');
    instance.unmount();
  };

  return ___EmotionJSX(Tippy, _extends({
    placement: placement,
    animation: true,
    hideOnClick: false,
    onMount: handleOnMount,
    onHide: handleOnHide,
    followCursor: enableFollowCursor,
    offset: [0, theme.space.small],
    plugins: enableFollowCursor ? [followCursor] : [],
    render: attrs => ___EmotionJSX(motion.div, _extends({
      css: /*#__PURE__*/_css(_objectSpread(_objectSpread({}, theme.text.small), {}, {
        color: StylesTooltipVariables(theme, variation).color,
        maxWidth: 250,
        padding: StylesTooltipVariables(theme, variation).padding,
        background: StylesTooltipVariables(theme, variation).background,
        border: '1px solid',
        borderColor: StylesTooltipVariables(theme, variation).borderColor,
        borderRadius: StylesTooltipVariables(theme, variation).borderRadius,
        wordWrap: 'break-word',
        textAlign: 'center',
        position: 'relative',
        boxShadow: theme.boxShadow.base,
        zIndex: 10,
        transformOrigin: attrs['data-placement'] && getTransformOrigin(attrs['data-placement'])
      }), process.env.NODE_ENV === "production" ? "" : ";label:Tooltip;"),
      className: clsx('CK__Tooltip', className),
      role: "tooltip",
      variants: variants,
      animate: controls,
      initial: "hidden",
      transition: theme.motion.transition.base
    }, attrs), ___EmotionJSX(TippyArrow, {
      placement: attrs['data-placement'],
      variation: variation
    }), content)
  }, rest), children);
};

export default Tooltip;